export default "__VITE_ASSET__BehqSVvs__"